import { h, Component } from 'preact';
import styles from './radio_button_field_style';
import classNames from 'classnames';

export default class RadioButtonField extends Component {
  updateValue = (e) => {
    this.props.updateValue(e.target.value);
  }
  render({field,isValid,responses},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
      <div>
        { field.options.map( option => (
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name={field.mapping} value={option.value} onChange={this.updateValue} />{option.label}
            </label>
          </div>
        )) }
      </div>
		);
	}
}



// WEBPACK FOOTER //
// ./field_types/radio_button_field.js